export default "__VITE_ASSET__3f31763d__"